import { useTranslation } from 'react-i18next';
import { LiliTextArea, Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export const NonprofitAffiliationForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[16px] mt-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_AFFILIATION}>
        {({ onChange, value, error }) => {
          const isYesSelected = value === 'YES';

          return (
            <>
              <CustomRadioButton
                label={t('organic.nonprofitAffiliation.no')}
                value='NO'
                inputId='affiliation-no'
                onChange={onChange}
                checked={value === 'NO'}
                name={EddEmbeddedFields.EDD_NONPROFIT_AFFILIATION}
              />
              <CustomRadioButton
                label={t('organic.nonprofitAffiliation.yes')}
                value='YES'
                inputId='affiliation-yes'
                onChange={onChange}
                checked={value === 'YES'}
                name={EddEmbeddedFields.EDD_NONPROFIT_AFFILIATION}
              />

              {isYesSelected && (
                <div className='flex flex-col gap-2 mt-[-8px]'>
                  <Text.H10 className='text-text-main-tertiary'>
                    {t('organic.nonprofitAffiliation.detailsPrompt')}
                  </Text.H10>
                  <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_AFFILIATION_DETAILS}>
                    {({
                      onChange: onDetailsChange,
                      value: detailsValue,
                      error: detailsError,
                      onBlur,
                    }) => (
                      <LiliTextArea
                        value={detailsValue}
                        onValueChange={onDetailsChange}
                        errorMsg={detailsError?.message || ''}
                        externalErrorMessage={detailsError?.message || ''}
                        maxLength={100}
                        minHeight='min-h-[88px]'
                        placeholder={t('organic.nonprofitAffiliation.placeholder')}
                        onBlur={onBlur}
                      />
                    )}
                  </ControllerWrapper>
                </div>
              )}
              <FieldError
                error={error}
                testId={`${EddEmbeddedFields.EDD_NONPROFIT_AFFILIATION}-error`}
              />
            </>
          );
        }}
      </ControllerWrapper>
    </div>
  );
};
